let language = {
    CART_PROGRESSBAR_PRODUCT: "Select Product",
    CART_PROGRESSBAR_SHIP: "Enter Information",
    CART_PROGRESSBAR_PAYMENT: "Review and Pay",
}

export { language }
